/** Metadata for one row in a directory listing (before building DOM). */
export type WorkspaceDirEntryMeta = { name: string; kind: FileSystemHandleKind };

/**
 * Folders first, then files; names sorted case-insensitively (Notepad++-style tree).
 */
export function sortWorkspaceDirectoryEntries(entries: readonly WorkspaceDirEntryMeta[]): WorkspaceDirEntryMeta[] {
  return [...entries].sort((a, b) => {
    if (a.kind !== b.kind) return a.kind === "directory" ? -1 : 1;
    return a.name.localeCompare(b.name, undefined, { sensitivity: "base" });
  });
}
